import React from 'react'
import { mount } from 'enzyme'
import ModalHeader from '../ModalHeader'

describe('<ModalHeader />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      title: 'test title',
      onClose: () => {}
    }
    wrapper = mount(<ModalHeader {...props} />)
  })
  it('should render its proivded title prop', () => {
    const text = wrapper.find('ModalHeader__Title').text()
    expect(text).toEqual(props.title)
  })
  it('should call its onClose prop when the close button is clicked', () => {
    wrapper.setProps({ onClose: jest.fn() })
    const closeButton = wrapper.find('#smart_rate_close').hostNodes()
    closeButton.simulate('click')
    expect(wrapper.prop('onClose')).toHaveBeenCalledTimes(1)
  })
})
